import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Button, Column, Icon, Panel, Radio, Row, Select, TextInput } from '../../components';
import DataTable from '../../components/components/Table/DataTable';
import Logger from '../../shared/services/Logger';
import { GetCustomerDataQuery } from "../model/GetCustomerDataQuery";
import * as docuMateConstant from '../shared/util/docuMateConstant';
import * as documateLabel from '../shared/util/docuMateLabel';
import './DocuMateIndexing.scss';
import DocuMateIndexingService from './DocuMateIndexingService';
import { ConfirmModal } from '../../shared/components/confirmModal';
import insuranceProducts from '../../shared/components/insuranceProductList/InsuranceProductList.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import * as constant from '../../shared/util/constant';
import DocHistoryModel from '../model/DocHistoryModel'
import { ErrorBoundary } from 'react-error-boundary'
import { FallbackComponent } from '../../shared/components/FallbackComponent'
import { policyTypeIconMapping } from '../../shared/components/insuranceProductList/InsuranceProductListService';
import DocViewer from './../shared/components/DocViewer';
import DocuMateScanService from './../DocuMateScan/DocuMateScanService';
import { GetFolderListByGroupIdQuery } from '../model/GetFolderListByGroupIdQuery';
import { Button as ReactButton } from 'primereact/button';
import { Form, FloatingLabel } from 'react-bootstrap';
import { AbilityContext } from '../../shared/abilities/AbilityContext';

interface DocuMateIndexingProps {
    id?: string;
    scanId?: string;
}



const DocuMateIndexing: React.FC<DocuMateIndexingProps> = (props) => {
    const ability = useContext(AbilityContext);
    const [showCustomerGrid, setShowCustomerGrid] = useState(false);
    const [showPolicyDetails, setShowPolicyDetails] = useState(false);
    const [showOneStepPanel, setShowOneStepPanel] = useState(false);    
    const [selectedRefNum, setSelectedRefNum] = useState('');
    const [selectedAppId, setSelectedAppId] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [isSearchValid, setIsSearchValid] = useState(true);
    const [customerRecord, setCustomerRecord] = useState([]);
    const [custPolicies, setCustPolicies] = useState([]);
    const [expandedPolicy, setExpandedPolicy] = useState(null);
    const [selectedTerm, setSelectedTerm] = useState(null);

    const location = useLocation();
    const state = location.state as { scanId: string, id: string, docStatus: string, documentUserId:string, queueDocs?: DocuMateIndexingProps[] };
    //const campaignId = state?.entityId;
    const urlParam = new URLSearchParams(location.search)
    const [scanId, setScanId] = useState(state?.scanId);
    const [id, setId] = useState(state?.id || urlParam.get('id'));
    const docStatus = state?.docStatus;
    const documentUserId = state?.documentUserId;
    const [queueDocs, setQueueDocs] = useState<DocuMateIndexingProps[]>(state?.queueDocs || []);
    const isQueueMode = queueDocs.length > 0;
    const queueTransitionRef = useRef(false);
    const docuMateIndexingServiceObj = new DocuMateIndexingService();
    const [documentTypeOption, setDocumentTypeOption] = useState('');
    const [userOption, setSelectedUserOption] = useState('');
    const [redirectReasonOption, setRedirectReasonOption] = useState('');
    const [selectedFolderOption, setSelectedFolderOption] = useState('');
    const [selectedGroupOption, setSelectedGroupOption] = useState('');
    const [sampleDocumentType, setSampleDocumentType] = useState([]);
    const [sampleGroup, setSampleGroup] = useState([]);
    const [sampleFolder, setsampleFolder] = useState([]);
    const [sampleRedirectReason, setsampleRedirectReason] = useState([]);
    const [userList, setUserList] = useState([]);
    const [selectedRadioType, setRadioType] = useState('');

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [modalBody, setModalBody] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const userDetails = useSelector((state: any) => state.userContextSlice);
    const history = useHistory();
    const [newNote, setNewNote] = useState('');
    const [noteError, setNoteError] = useState(false);
    const [docHistory, setDocHistory] = useState<DocHistoryModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [redirectNoteTxt, setRedirectNoteTxt] = useState('');
    const [whichBtnClickedForModal, setWhichBtnClickedForModal] = useState('');
    const [groupName, setGroupName] = useState('');
    const [folderName, setFolderName] = useState('');
    const [indexGroupId, setIndexGroupId] = useState('');
    const [indexFolderid, setIndexFolderid] = useState('');
    const [docFileId, setDocFileId] = useState<string | null>(null);
    const [docNameAPI, setDocNameAPI] = useState('');
    const [docPdf, setDocPDf] = useState<any>(null);
    const documateServiceObj = new DocuMateScanService();
    const [newRedirectNote, setNewRedirectNote] = useState('');
    const [formValidation, setFormValidation] = useState<any>({});
    const [isRedirectNoteRequired, setIsRedirectNoteRequired] = useState(false);
    const [documentTypeId, setDocumentTypeId] = useState(null);
    const [haveDelCloseAccess, setHaveDelCloseAccess] = useState(false);
    const [isOneStepSelected, setIsOneStepSelected] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false); 

    const navigateTo = (location: string) => {
        history.push(location)
    }

    const advanceQueueOrExit = async () => {
        if (queueTransitionRef.current) return;
        queueTransitionRef.current = true;
        try {
            const exitState = { groupIdFromIndexing: indexGroupId, folderIdFromIndexing: indexFolderid };
            if (!isQueueMode) {
                history.push({ pathname: `/documate-indexing`, state: exitState });
                return;
            }

            const remainingQueueDocs = queueDocs.filter(doc => doc.id.toLowerCase() !== id.toLowerCase());
            setQueueDocs(remainingQueueDocs);
            if (remainingQueueDocs.length === 0) {
                history.replace({ pathname: `/documate-indexing`, state: exitState });
                return;
            }
            // remaining queue always includes the next document to open as its first element
            const nextDoc = remainingQueueDocs[0];
            history.replace({
                pathname: `/documate-indexing/processing/${nextDoc.id}`,
                state: {
                    id: nextDoc.id,
                    scanId: nextDoc.scanId,
                    docStatus: 'working',
                    documentUserId: userDetails?.userContext?.id,
                    queueDocs: remainingQueueDocs
                }
            });
        } catch (error) {
            Logger.logError(String(error));
            toast.error(docuMateConstant.AUTOPROCESS_CANNOT_PROCEED, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
        } finally {
            queueTransitionRef.current = false;
        }
    }

    const firstControlRef = useRef(null);
    const lastButtonRef = useRef(null);

    useEffect(() => {
        const initializeDocument = async () => {
            if (isQueueMode) {
                docuMateIndexingServiceObj.hardLockDocument(id!);
            }
 
            CheckCurrentUserAccessToDeleteClose();
 
            if (id) {
                await DocFetailsById(id);
            }
 
            await Promise.allSettled([
                FetchGroupDocData(),
                FetchRedirectReason(),
                DomainEventNotes()
            ]);
 
            disableButtons();
        };
 
        initializeDocument();
    }, [id, isQueueMode]);

     const disableButtons=() =>{
        // disable few buttons when this document is being indexed by some other user
        // checking docStatus is working or not
        if(documentUserId !=='' && documentUserId !== userDetails?.userContext?.id && documentUserId !== constant.DEFAULT_GUID){
            setIsDisabled(true);
        }
    }

    const CheckCurrentUserAccessToDeleteClose = () => {
        try {
            if (ability.can('view', docuMateConstant.TODO_LIST_GroupSubject, docuMateConstant.Indexing_Delete_Close_Field) && ability.can('read', docuMateConstant.TODO_LIST_GroupSubject, docuMateConstant.Indexing_Delete_Close_Field)) {
                setHaveDelCloseAccess(true);
            }
        }
        catch (error) {
            Logger.logError(error.toString());
        }
    }

    const DocFetailsById = async (queuedDocId: string) => {
        const data = await docuMateIndexingServiceObj.GetDocumentFileDetailsById(queuedDocId);
        const resolvedScanId = data?.documentName || scanId;
        const resolvedDocFileId = data?.docFileId && String(data.docFileId).trim() ? data.docFileId : null;
        setGroupName(data.groupName);
        setFolderName(data.folderName);
        setIndexGroupId(data.groupId);
        setIndexFolderid(data.folderId);
        setDocFileId(resolvedDocFileId);
        setDocumentTypeId(data.documentTypeId);
        setScanId(resolvedScanId);
        if (!resolvedDocFileId) {
            setDocNameAPI('');
            setDocPDf(null);
            return;
        }
 
        await FetchDocument(resolvedDocFileId, resolvedScanId);
        if (data.groupId == docuMateConstant.SALES_GROUP) {
            firstControlRef.current.click();
        }
    }

    const handleSearchButtonClick = (): void => {
        if (validateSearch()) {
            const getCustomerDataQueryModel = {
                AppId: selectedAppId,
                RefrenceNbr: searchValue,
                type: selectedRadioType
            };

            FetchCustomerData(getCustomerDataQueryModel);
        }
        else {
            setShowCustomerGrid(false);
            setShowPolicyDetails(false);
            setShowOneStepPanel(false);
        }
    }


    const FetchCustomerData = async (getCustomerDataQueryModel: GetCustomerDataQuery) => {
        try {
             setShowOneStepPanel(false);
            // Fetch data from the service
            let customerDataResponseDto = await docuMateIndexingServiceObj.GetCustomerData(getCustomerDataQueryModel);
          

            if (
                !Array.isArray(customerDataResponseDto) ||
                customerDataResponseDto.length === 0 ||
                customerDataResponseDto.some(item => typeof item !== 'object' || item === null)
            ) {

                setCustomerRecord([]);
                setShowCustomerGrid(true);
                setCustPolicies([]);
                if (selectedRefNum === 'advRefNum') {
                    setShowPolicyDetails(false);
                    setShowOneStepPanel(false);
                }
                else {                     
                    setShowPolicyDetails(true);
                    setShowOneStepPanel(false);
                }
                toast.warn("No Data Found.");
                return;
            }


            const processedData = customerDataResponseDto.map((item) => ({
                cs2RefNum: item.cs2RefNum || '',
                advRefNum: item.advRefNum || '',
                status: item.status || '',
                fullName: `${item.title || ''} ${item.firstName || ''} ${item.lastName || ''}`.trim(),
            }));


            if (processedData.length > 0) {
                setCustomerRecord(processedData);
                setShowCustomerGrid(true);
            } else {
                setCustomerRecord([]);
                setShowCustomerGrid(true);
            }           
            
            if (
                Array.isArray(customerDataResponseDto[0]?.customerPolicyData) &&
                customerDataResponseDto[0].customerPolicyData.length > 0
            ) {               
                //const groupedPolicies = groupPoliciesByNumber(customerDataResponseDto[0].customerPolicyData);
                const policiesWithTabIndex = addTabIndexToGroupedPolicies(customerDataResponseDto[0].listOfPolicyGroupWithTerm);
                setShowPolicyDetails(true);
                setShowOneStepPanel(false);
                setCustPolicies(policiesWithTabIndex);
            } else {
                 setShowPolicyDetails(false);
                 setCustPolicies([]);             
                if( Number(selectedAppId) === Number(docuMateConstant.cs2RefNum) && String(selectedRefNum) === 'cs2RefNum') 
                {                   
                    setShowOneStepPanel(true);
                }               
            }
        } catch (error) {

            Logger.logError(error.toString());
            setShowCustomerGrid(false);
        }
    };

    const handleIndexButtonclick = async (endAutoProcessing = false) => {
        const validationErrors = docuMateIndexingServiceObj.validateIndexDocumentType(documentTypeOption);

        setFormValidation((prev) => ({
            ...prev,
            documentType: validationErrors['documentType'] || { isValid: true, warningText: '' }
        }));

        if (validationErrors['documentType']) {
            return;
        }

        let customerData = customerRecord.length > 0 ? customerRecord[0] : null;
        if (customerData !== null) {
            try {
                let indexKey1 = '';
                let indexkey2 = '';
                let attributes = '';

                if (customerData.advRefNum !== '') {
                    indexKey1 = customerData.advRefNum;
                }
                else if (customerData.cs2RefNum !== '') {
                    indexKey1 = customerData.cs2RefNum;
                    // checking if customer has no policies and One Step folder/panel is showing
                    if((custPolicies === undefined || custPolicies.length === 0) && showOneStepPanel && !showPolicyDetails)
                    {
                         indexkey2 = '';
                         let attributesVal =
                            {
                                FolderStructure: docuMateConstant.NoPolicyFolderName
                            }

                            attributes = JSON.stringify(attributesVal);
                    }
                    else
                        {
                          indexkey2 = selectedTerm?.policyNumber || '';
                            if (selectedTerm !== null) {
                                let attributesVal =
                                {
                                    Term: moment(selectedTerm.polEffDate).format('MM/DD/YYYY') + ' to ' +
                                        moment(selectedTerm.polExpDate).format('MM/DD/YYYY')
                                }

                                attributes = JSON.stringify(attributesVal);
                            }                  
                            else {
                                toast.error(docuMateConstant.Indexing_Term_Mandatory, {
                                    position: toast.POSITION.TOP_RIGHT,
                                    autoClose: constant.AUTO_CLOSE
                                });
                                return;
                            }
                        }
                }

                await docuMateIndexingServiceObj.IndexDocument(id, selectedAppId, documentTypeOption, indexKey1, indexkey2, attributes);
                if(endAutoProcessing) {
                    const response = await docuMateIndexingServiceObj.releaseSoftLockDocuments();
                    if (!response?.isUpdated) {
                        throw new Error('Unable to release remaining soft locks.');
                    }
                    
                    history.push({
                        pathname: '/documate-indexing',
                        state: {
                            groupIdFromIndexing: indexGroupId,
                            folderIdFromIndexing: indexFolderid
                        }
                    });
                }
                else{
                    await advanceQueueOrExit();
                }
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
            }
        }
    }
    
    const handleSkipButtonclick = async () => {
        if (queueTransitionRef.current || !id || queueDocs.length <= 1) return;

        queueTransitionRef.current = true;
        try {
            // Unlock from hardlock state and mark as softlock
            const unlockResponse = await docuMateIndexingServiceObj.toggleDocumentLock(id, false);
            const softLockResponse = await docuMateIndexingServiceObj.toggleDocumentLock(id, true);

            if (!unlockResponse?.isUpdated || !softLockResponse?.isUpdated) {
                throw new Error('Unable to skip document.');
            }
            
            // Fetch the current document and place it at the end of the queue
            const currentDocument = queueDocs.find(doc => doc.id?.toLowerCase() === id.toLowerCase());
            const skippedQueue = [
                ...queueDocs.filter(doc => doc.id?.toLowerCase() !== id.toLowerCase()),
                currentDocument!
            ];

            const nextDoc = skippedQueue[0];

            setQueueDocs(skippedQueue);
            history.replace({
                pathname: `/documate-indexing/processing/${nextDoc.id}`,
                state: {
                    id: nextDoc.id,
                    scanId: nextDoc.scanId,
                    docStatus: 'working',
                    documentUserId: userDetails?.userContext?.id,
                    queueDocs: skippedQueue
                }
            });
        } catch (error) {
            Logger.logError(String(error));
            toast.error(docuMateConstant.AUTOPROCESS_CANNOT_PROCEED, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
        } finally {
            queueTransitionRef.current = false;
        }
    }

    //const groupPoliciesByNumber = (policies) => {
    //    // Enum order for sorting
    //    const policyTypeOrder = [
    //        "HO1", "HO2", "HO3", "HO4", "HO5", "HO6", "HO7", "HO8", "HOA", "HOB", "HOC", "AUTO", "FLOOD", "EARTHQUACK"
    //    ];

    //    // Separate policies with null policyType
    //    const nonNullPolicies = policies.filter(p => p.policyType !== null);
    //    // Sort non-null policies by policyType according to enum order
    //    nonNullPolicies.sort((a, b) => {
    //        const aTypeIdx = policyTypeOrder.indexOf(a.policyType);
    //        const bTypeIdx = policyTypeOrder.indexOf(b.policyType);
    //        // If not found, put at end
    //        return (aTypeIdx === -1 ? Number.MAX_SAFE_INTEGER : aTypeIdx) - (bTypeIdx === -1 ? Number.MAX_SAFE_INTEGER : bTypeIdx);
    //    });
    //    const nullPolicies = policies.filter(p => p.policyType === null);

    //    let mergedPoliciesCollection = [...nonNullPolicies, ...nullPolicies];

    //    return mergedPoliciesCollection.reduce((acc, policy) => {
    //        const policyNumber = policy?.policyNumber || 'Unknown';
    //        if (!acc[policyNumber]) {
    //            acc[policyNumber] = [];
    //        }
    //        acc[policyNumber].push(policy);
    //        return acc;
    //    }, {});
    // };


    const handleTogglePolicy = (policyId) => {
        setExpandedPolicy(expandedPolicy === policyId ? null : policyId);
    };

    const handleTermSelect = (policy) => {
        setSelectedTerm(policy);
    }

    const FetchDocumentType = async (appid) => {
        try {

            const getDocumentTypeListRequestModel = { AppId: appid };
            const response = await docuMateIndexingServiceObj.getListOfDocumentType(getDocumentTypeListRequestModel);
            setSampleDocumentType(response);
            const defaultDocType = response.find(item => item.value === documentTypeId);
            setDocumentTypeOption(defaultDocType ? defaultDocType.value : '');
        }
        catch (err) {
            console.error('Error fetching document types:', err.message);
        }

    };

    const resetStates = () => {
        setShowCustomerGrid(false);
        setShowPolicyDetails(false);
        setSelectedRefNum('');
        setSelectedAppId(0);
        setSearchValue('');
        setIsSearchValid(true);
        setCustomerRecord([]);
        setDocumentTypeOption('');
        setSelectedTerm(null);
        setRadioType('');
    };

    const onRadioButtonRefnoClick = (event) => {

        resetStates();

        const refNumMapping = {
            advRefNum: docuMateConstant.advRefNum,
            cs2RefNum: docuMateConstant.cs2RefNum,
            polRefNum: docuMateConstant.polRefNum
        };

        const selectedRefNum = event.target.id;
        const selectedAppId = refNumMapping[selectedRefNum];
        setSelectedRefNum(selectedRefNum);
        setSelectedAppId(selectedAppId);
        setRadioType(selectedRefNum);
        if (selectedRefNum === 'advRefNum') {
            setShowPolicyDetails(false);
        }
        if (refNumMapping[selectedRefNum]) {
            FetchDocumentType(refNumMapping[selectedRefNum]);
        }

    };

    const handleDocumentTypeChange = async (selectedOption) => {

        setDocumentTypeOption(selectedOption.toString());

    }

    function handleDocViewerClose(): void {
        throw new Error('Function not implemented.');
    }

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setSearchValue(event.target.value);
        setIsSearchValid(true);
    }

    const validateSearch = (): boolean => {
        if (selectedRefNum === '' || selectedRefNum === null || selectedRefNum === undefined) {
            toast.warn('Please select a reference number');
            return false;
        }
        if (selectedAppId === 0 || selectedAppId === null || selectedAppId === undefined) {
            toast.warn('Please select a radio option');
            return false;
        }
        if (searchValue === '' || searchValue === null || searchValue === undefined) {
            setIsSearchValid(false);
            return false;
        }

        return true;
    }

    const getPolicyIcon = (policyTypeId) => {
        if (!policyTypeId) {
            return 'circle-question';
        }
        const iconId = policyTypeIconMapping[policyTypeId];
        const product = insuranceProducts.find((item) => item.id === iconId);
        return product?.icon || 'circle-question';
    };

    const getStatus = () => {
        switch (docStatus) {
            case 'working':
                return 'userPen';
            default:
                return 'lock';
        }
    }

    const getStatusIcon = (
        <span>
            {docStatus !== '' && <Icon icon={getStatus()} outline={false}></Icon>}
        </span>
    );

    const FetchGroupDocData = async () => {
        try {
            const groupData = await docuMateIndexingServiceObj.GetListOfGroup()
            setSampleGroup(groupData);
        }
        catch (error) {

            Logger.logError(error.toString());
        }
    };


    const onGroupSelectChange = async (selectedOption) => {

        setSelectedGroupOption(selectedOption ? selectedOption.toString() : '');
        const groupId = selectedOption ? selectedOption.toString() : '';
        if (!groupId) {
            setsampleFolder([]);
            setSelectedFolderOption('');
            setUserList([]);
            return;
        }
        //fetch folders based on groupId        
        FetchFolderListByGroupId(groupId);

        //fetch users based on groupId        
        let groupIdList = [groupId];
        FetchUsersData(groupIdList);
    }

    const FetchFolderListByGroupId = async (groupId) => {
        try {
            const getFolderListByGroupIdRequestModel: GetFolderListByGroupIdQuery = {
                GroupId: groupId,
                screenName: "Indexing",
            }
            const data = await docuMateIndexingServiceObj.GetFolderListByGroupId(getFolderListByGroupIdRequestModel);
            setsampleFolder(data);
        }
        catch (error) {

            Logger.logError(error.toString());
        }
    }

    const FetchUsersData = async (groupIdList) => {
        try {
            const data = await docuMateIndexingServiceObj.getUsersToDoList(groupIdList);
            setUserList(data);
        }
        catch (error) {

            Logger.logError(error.toString());
        }
    }

    const FetchRedirectReason = async () => {
        try {
            const data = await docuMateIndexingServiceObj.GetRedirectReason();
            setsampleRedirectReason(data);
        }
        catch (error) {

            Logger.logError(error.toString());
        }
    }

    const handleFolderChange = async (selectedOption) => {
        setSelectedFolderOption(selectedOption.toString());
    }

    const handleUserChange = async (selectedOption) => {
        setSelectedUserOption(selectedOption.toString());
    }

    const handleRedirectReasonChange = async (selectedOption) => {        
        setRedirectReasonOption(selectedOption.toString());
        setIsRedirectNoteRequired(selectedOption.toString() === docuMateConstant.redirectReasonMandatory 
                                   || selectedOption.toString() === docuMateConstant.redirectReasonOther);

        // If the selected reason is not mandatory, clear the redirectNote validation
        if (selectedOption.toString() !== docuMateConstant.redirectReasonMandatory ||
            selectedOption.toString() !== docuMateConstant.redirectReasonOther) {
            setFormValidation((prev) => ({
                ...prev,
                redirectNote: { isValid: true, warningText: '' }
            }));
        }
    }



    const DomainEventNotes = async () => {
        setLoading(true)
        try {
            const data = await docuMateIndexingServiceObj.GetDocHistory(id);
            let modifiedData = data.map(item => ({
                ...item,
                combinedKey: `${item.changedBy}-${item.changedDate}`
            }));
            setDocHistory(modifiedData)
        }
        catch (error) {
            Logger.logError(error.toString());
            toast.error("Failed to Load notes.");
        }
        setLoading(false);
    }

    const GetDocumentFileDetailsById = async () => {
        try {
            setModalBody(
                <div className='documate-onhold-popup'>
                    <p>
                        Are you sure you want to put<br />
                        <strong>{scanId}</strong>
                        <br />ON HOLD?
                    </p>
                    <p style={{ margin: "16px 0 0 0" }}>
                        It will be returned to:<br />
                        <strong>
                            {groupName}
                            {groupName && folderName ? " - " : ""}
                            {folderName}
                        </strong>
                    </p>
                </div>
            );

            setShowConfirmModal(true); // Show the modal
        } catch (error) {

            Logger.logError(error.toString());
        }
    };


    const handlePlaceOnHold = async () => {
        setWhichBtnClickedForModal(documateLabel.DOCUMATE_INDEXING_BUTTONS.placeOnHold);
        GetDocumentFileDetailsById();
        setShowConfirmModal(true);
    };

    const modalSuccess = async (btnValue) => {
        if (btnValue === documateLabel.DOCUMATE_INDEXING_BUTTONS.placeOnHold) {
            setShowConfirmModal(false); // Close the modal
            setWhichBtnClickedForModal('');
            try {
                const response = await docuMateIndexingServiceObj.updateDocumentStatusForOnHold(id);
                if (response?.isUpdated === true) {
                    await advanceQueueOrExit();
                }
            } catch (error) {

                Logger.logError(error.toString());
            }
        }
        else if (btnValue === documateLabel.DOCUMATE_INDEXING_BUTTONS.reset) {
            resetStates(); // Call the existing resetStates function
            setSelectedGroupOption('')
            setsampleFolder([]);
            setSelectedFolderOption('');
            setSelectedUserOption('');
            setRedirectReasonOption('');
            setNewRedirectNote('');
            setShowConfirmModal(false);
            setWhichBtnClickedForModal('');
            // Update validation state for UI
            setFormValidation({
                group:  { isValid: true, warningText: '' },
                folder: { isValid: true, warningText: '' },
                redirectReason:  { isValid: true, warningText: '' },
                redirectNote:  { isValid: true, warningText: '' }
            });

        }
        else if (btnValue === documateLabel.DOCUMATE_INDEXING_BUTTONS.delete) {
            setShowConfirmModal(false); // Close the modal
            setWhichBtnClickedForModal('');
            deleteDocFunction(id);
        }
    }

    const deleteDocFunction = async (id:string) =>{
          try {

                let resDeleted = await docuMateIndexingServiceObj.deleteDocument([id]);

                if (resDeleted != null) {
                    await advanceQueueOrExit();
                }
            } catch (error) {
                toast.error(docuMateConstant.Delete_Error_Message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });

                Logger.logError(error.toString());
            }
    }

    const handleReset = () => {
        setWhichBtnClickedForModal(documateLabel.DOCUMATE_INDEXING_BUTTONS.reset);
        setModalBody(
            <>
                <p>Are you sure you want to clear the data entered on <strong>{scanId}</strong> </p>
            </>
        );
        setShowConfirmModal(true);
    };

    const handleDelete = () => {
        setWhichBtnClickedForModal(documateLabel.DOCUMATE_INDEXING_BUTTONS.delete);
        setModalBody(
            <>
                <p>Are you sure you want to Delete <strong>{scanId}</strong> and send it to the <strong>Recycle Bin</strong>?</p>
            </>
        );
        setShowConfirmModal(true);
    };

    const handleClose = async () => {
        try {
            let response = await docuMateIndexingServiceObj.CloseDocument(id);
            if (response.isUpdated)
                await advanceQueueOrExit();
        }
        catch (error) {
            toast.error(docuMateConstant.Error_On_Close, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const handleUpdate = async () => {
        const redirectDocumentCommand = {
            QueuedDocId: id,
            GroupId: selectedGroupOption,
            FolderId: selectedFolderOption,
            UserId: userOption ? userOption : null,
            RedirectReason: redirectReasonOption,
            RedirectNote: newRedirectNote ? newRedirectNote : ""
        };

        // Use the service's validation method
        const validationErrors = docuMateIndexingServiceObj.validateRedirectDocument(redirectDocumentCommand);

        // Update validation state for UI
        setFormValidation({
            group: validationErrors['GroupId'] || { isValid: true, warningText: '' },
            folder: validationErrors['FolderId'] || { isValid: true, warningText: '' },
            redirectReason: validationErrors['RedirectReason'] || { isValid: true, warningText: '' },
            redirectNote: validationErrors['RedirectNote'] || { isValid: true, warningText: '' },
            ...validationErrors
        });

        // Show the first warning if any
        const firstError = Object.values(validationErrors).find(err => err && err.warningText);
        if (firstError && firstError.warningText) {
            return;
        }

        if(redirectDocumentCommand.FolderId && redirectDocumentCommand.FolderId.toLowerCase() === docuMateConstant.Parked_CP.toLowerCase() && redirectDocumentCommand.RedirectReason.toLowerCase() === docuMateConstant.RedirectReason_Junk.toLowerCase())
        {
              // folderid=CP parked (E11A99CB-9F2D-437F-B6E8-9602CB34A4DB) then call delete function
              deleteDocFunction(redirectDocumentCommand.QueuedDocId);
        }
        else
        {
              try {
                    const redirectDataResponseDto = await docuMateIndexingServiceObj.UpdateRedirectData(redirectDocumentCommand);
                    if (redirectDataResponseDto?.isUpdated === true) {
                        await advanceQueueOrExit();
                    }
                } catch (exception) {
                    Logger.logError(exception.toString());

                    if (exception?.data?.error === docuMateConstant.DocumentNotFoundError) {
                        toast.error(docuMateConstant.UpdateErrorDocNotFound);
                    }
                    else {
                        toast.error(docuMateConstant.UpdateErrorGeneric);
                    }
                }
          }
    };

    const handleAddNote = async () => {
        if (!newNote || newNote.trim() === "") {
            setNoteError(true);
            toast.warn("Please enter a note before submitting.");
            return;
        }
        setNoteError(false);
        try {
            const data = await docuMateIndexingServiceObj.AddDocNotes(id, newNote);
            toast.success("Note added successfully!");
            setNewNote(""); // Clear the input after success

            let modifiedData = data.map(item => ({
                ...item,
                combinedKey: `${item.changedBy}-${item.changedDate}`
            }));
            setDocHistory(modifiedData)
        } catch (error) {
            Logger.logError(error.toString());
            toast.error("Failed to add note.");
        }
    };

    const handlePolicyHeaderKeyDown = (e, policyNumber) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleTogglePolicy(policyNumber);
        }
    };

    // Assign tabIndex to each policy header and each term (when expanded)
    const addTabIndexToGroupedPolicies = (groupedPolicies, startTabIndex = 18) => {
        if (!groupedPolicies || Object.keys(groupedPolicies).length === 0) return groupedPolicies;
        let tabIndex = startTabIndex;
        const result = {};
        Object.entries(groupedPolicies).forEach(([policyNumber, policies]) => {
            // Attach tabIndex to the first policy object (header)
            let headerPolicy = { ...policies[0], tabIndex };
            tabIndex++;
            // Attach tabIndex to each term (policy) as well
            let policiesWithTab = [headerPolicy];
            for (let i = 1; i < policies.length; i++) {
                policiesWithTab.push({ ...policies[i], tabIndex });
                tabIndex++;
            }
            result[policyNumber] = policiesWithTab;
        });
        return result;
    };

    const renderPoliciesPanel = (groupedPolicies) => {
        if (!groupedPolicies || Object.keys(groupedPolicies).length === 0) {
            return { panel: <div>No record found.</div>, lastTabIndex: 17 };
        }
        let policyHeaders = Object.entries(groupedPolicies);
        // Find last tabIndex for notes footer
        let lastTabIndex = 17;
        if (policyHeaders.length > 0) {
            const lastHeaderPolicies = policyHeaders[policyHeaders.length - 1][1];
            lastTabIndex = lastHeaderPolicies[lastHeaderPolicies.length - 1]?.tabIndex || 17;
        }
        return {
            panel: (
                <div className="policiesPanel">
                    {policyHeaders.map(([policyNumber, policies]) => (
                        <div key={policyNumber}>
                            {/* Render Policy Header */}
                            <div
                                key={`header-${policyNumber}`}
                                className={`policiesList ${expandedPolicy === policyNumber ? 'clicked' : ''}`}
                                onClick={() => handleTogglePolicy(policyNumber)}
                            >
                                {/* Expand/Collapse Icon */}
                                {expandedPolicy === policyNumber ? <FaChevronDown /> : <FaChevronRight />}
                                <span
                                    className="policy-header"
                                    tabIndex={0}
                                    role="button"
                                    aria-expanded={expandedPolicy === policyNumber}
                                    onKeyDown={(e) => handlePolicyHeaderKeyDown(e, policyNumber)}
                                >
                                    {/* Display Policy Type and Number */}
                                    <FontAwesomeIcon
                                        icon={getPolicyIcon(policies[0]?.policyTypeId)} // Use the first policy in the array for the header
                                        className="policyIcons"
                                    />
                                    {policyNumber}
                                </span>
                            </div>

                            {/* Render Policy Terms */}
                            {expandedPolicy === policyNumber && (
                                <div className="policy-terms">
                                    {policies.map((policy) => (
                                        <div
                                            key={policy.policyId}
                                            className={`termsList ${
                                                selectedTerm?.policyId === policy.policyId ? 'selectedTerm' : ''
                                                }`}
                                            onClick={() => handleTermSelect(policy)}
                                            tabIndex={policy.tabIndex}
                                        >
                                            <Icon icon="calendar2" className="policyIcons" outline={false} />
                                            Term {moment(policy.polEffDate).format('MM/DD/YYYY')} to{' '}
                                            {moment(policy.polExpDate).format('MM/DD/YYYY')}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ),
            lastTabIndex
        };
    };

    const { panel: policiesPanel, lastTabIndex } = renderPoliciesPanel(custPolicies);

    const renderNotes = (docHistory) => {
        const customOrderDefault = ['QueueId', 'AssignedTo', 'LastRedirectedReason', 'LastRedirectedNote'];
        const customOrderMR = ['AssignedTo', 'LastRedirectedNote', 'QueueId', 'LastRedirectedReason',];

        const groupedData = docHistory.reduce((acc, item) => {
            const formattedTime = moment(item.changedDate).format('MM/DD/YYYY hh:mm A');

            if (!acc[formattedTime]) {
                acc[formattedTime] = [];
            }

            acc[formattedTime].push(item);

            acc[formattedTime].sort((a, b) => {
                const order = a.eventType === 'RedirectMR' ? customOrderMR : customOrderDefault;
                const indexA = order.indexOf(a.fieldName);
                const indexB = order.indexOf(b.fieldName);
                return indexA - indexB;
            });

            return acc;
        }, {});

        return (
            <div className="redirectnotepanel">
                <ErrorBoundary FallbackComponent={FallbackComponent}>
                    {loading ? (
                        <span>Loading...</span>
                    ) : Object.keys(groupedData).length > 0 ? (
                        Object.entries(groupedData).map(([formattedTime, group]: [string, DocHistoryModel[]], groupIndex) => (
                            <div key={groupIndex} className="note-item">
                                <div className="note-header">
                                    <Row>
                                        <Column lg={12}>
                                            <span className="note-content">
                                                {group.map((history, hIndex) => (
                                                    <span key={hIndex}>
                                                        {history.eventType === "RedirectMR" ?
                                                            (
                                                                <span>

                                                                    {history.fieldName === "AssignedTo" && (
                                                                        <>
                                                                            <strong>Review: </strong>{history.changedBy} at <strong className='align-right'>{formattedTime}</strong>
                                                                            <br />
                                                                            <strong>Assigned: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {history.fieldName === "LastRedirectedNote" && (
                                                                        <>
                                                                            <strong>Redirect Note: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {history.fieldName === "QueueId" && (
                                                                        <>
                                                                            <strong>Documemt Returned: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                </span>
                                                            )
                                                            :
                                                            history.eventType === "Redirect Document" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "QueueId" && (
                                                                            <>
                                                                                By <strong>{history.changedBy}</strong> at <strong className='align-right'>{formattedTime} </strong>
                                                                                <br />
                                                                                <strong>Document Redirected: </strong>{history.oldValue} folder to {history.newValue} folder
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "AssignedTo" && (
                                                                            <>
                                                                                <span> to {history.newValue} </span>
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "LastRedirectedReason" && (
                                                                            <>
                                                                                <br />
                                                                                <strong>Redirect Reason: </strong>{history.newValue}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "LastRedirectedNote" && (
                                                                            <>
                                                                                <strong>Redirect Note: </strong>{history.newValue}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                )
                                                                :
                                                                history.eventType === "Document Scanned" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "DocumentScanned" && (
                                                                                    <>
                                                                                        <span>Scanned By <strong className="username">{history.changedBy}</strong>on <strong className='align-right'>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong> </span>
                                                                                        <br />
                                                                                    </>
                                                                        )}
                                                                    </span>
                                                                )
                                                                :
                                                                history.eventType === "Document Emailed" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "IsFromEmail" && (
                                                                                    <>
                                                                                        <span>Received in email inbox on <strong className='align-right'>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong></span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                    </span>
                                                                )
                                                                :
                                                                (
                                                                    <span key={hIndex}>
                                                                        <Row>
                                                                            <Column lg={6}>
                                                                                <strong className="username">{history.changedBy}</strong>
                                                                                <span className="timestamp">{history.eventType}</span>
                                                                            </Column>
                                                                            <Column lg={6} style={{ textAlign: "right" }}>
                                                                                <span>
                                                                                    <strong>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong>
                                                                                </span>
                                                                            </Column>
                                                                            <Column lg={8}>
                                                                                {history.fieldName === "OnHold" && (
                                                                                    <>
                                                                                        <span>Document Status changed to {history.newValue}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}                                                                                
                                                                                {history.fieldName === "LatestNotes" && (
                                                                                    <>
                                                                                        <span className="note-content">{history.newValue}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                            </Column>
                                                                        </Row>
                                                                    </span>
                                                                )}
                                                    </span>
                                                ))}
                                            </span>
                                        </Column>
                                    </Row>
                                </div>
                                <br />
                            </div>
                        ))) : (
                        <div>No Notes/Events found</div>
                    )}
                </ErrorBoundary>
            </div>
        );
    };

    const FetchDocument = async (id: string, resolvedDocumentName?: string) => {
        try {
            let documentResponse = await documateServiceObj.getDocument(id);
            const resolvedDocName = resolvedDocumentName || scanId;
            setDocNameAPI(resolvedDocName);
            if (documentResponse?.blob) {
                setDocPDf(documentResponse.blob);
            } else {
                setDocPDf(null);
            }
        }
        catch (error) {
            setDocNameAPI('');
            setDocPDf(null);
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    // Track last policy header tabIndex for notes footer
    let lastPolicyTabIndex = 18 - 1; // default if no policies
    if (custPolicies && Object.keys(custPolicies).length > 0) {
        lastPolicyTabIndex = 18 + Object.keys(custPolicies).length - 1;
    }

    return (


        <div className='parent-container-indexing'>
            <div className='indexingPanel'>
                <Row>
                    <Column lg={6} md={6}>
                        <Panel title={scanId} panelHeaderItems={getStatusIcon} className='firstPanelClass'>
                            <Row style={{ paddingLeft: '15px', paddingBottom: '10px' }}>
                                <Form.Check
                                    type='radio'
                                    label={documateLabel.SEARCH_RADIO_LABELS.advRefNum}
                                    id='advRefNum'
                                    value='advRefNum'
                                    name='advRefNum'
                                    checked={selectedRefNum === 'advRefNum'}
                                    onClick={onRadioButtonRefnoClick}
                                    className='refNumberRadio inlineLable radio-button'
                                    tabIndex={1}
                                    ref={firstControlRef}
                                    onKeyDown={e => {
                                        if (e.key == "Tab" && e.shiftKey) {
                                            e.preventDefault();
                                            lastButtonRef.current?.focus();
                                        }
                                    }}
                                >
                                </Form.Check>
                                <Form.Check
                                    type='radio'
                                    label={documateLabel.SEARCH_RADIO_LABELS.cs2RefNum}
                                    id='cs2RefNum'
                                    value='cs2RefNum'
                                    name='cs2RefNum'
                                    checked={selectedRefNum === 'cs2RefNum'}
                                    onClick={onRadioButtonRefnoClick}
                                    className='refNumberRadio inlineLable radio-button'
                                    tabIndex={2}
                                >
                                </Form.Check>
                                <Form.Check
                                    type='radio'
                                    label={documateLabel.SEARCH_RADIO_LABELS.polRefNum}
                                    id='polRefNum'
                                    value='polRefNum'
                                    name='polRefNum'
                                    checked={selectedRefNum === 'polRefNum'}
                                    onClick={onRadioButtonRefnoClick}
                                    className='refNumberRadio inlineLable radio-button'
                                    tabIndex={3}
                                >
                                </Form.Check>


                            </Row>
                            <Row>
                                <Column lg={9} md={9}>

                                    <TextInput
                                        type='search'
                                        size='sm'
                                        value={searchValue} // Bind the value to the searchValue state
                                        onChange={handleSearchInputChange}
                                        placeholder={'Reference Number'}
                                        isInvalid={!isSearchValid}
                                        tabIndex={4}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleSearchButtonClick();
                                            }
                                        }}
                                    />
                                </Column>
                                <Column lg={3} md={3}>
                                    <Button
                                        className='btn btn-primary bt-main-action'
                                        size='small'
                                        key="filter"
                                        onClick={handleSearchButtonClick}
                                        id="searchIndexing"
                                        disabled={false}
                                        tabIndex={5}
                                    >
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.search}
                                    </Button>
                                </Column>
                            </Row>
                            <Row className='customertable'>
                                <Column lg={12} md={12} sm={12}>
                                    <Column lg={12} md={12} sm={12}>
                                        {showCustomerGrid && customerRecord && customerRecord.length > 0 ? (
                                            <div className="doc-index-cust-label-section">
                                                {customerRecord.map((item, index) => (
                                                    <div key={index} className="doc-index-cust-record">
                                                        {item.cs2RefNum && (
                                                            <div className="doc-index-cust-label-row">
                                                                <span className="doc-index-cust-label">{documateLabel.INDEXING_GRID_LABELS.cs2RefNum}:</span>
                                                                <span className="doc-index-cust-value">{item.cs2RefNum}</span>
                                                            </div>
                                                        )}
                                                        {item.advRefNum && (
                                                            <div className="doc-index-cust-label-row">
                                                                <span className="doc-index-cust-label">{documateLabel.INDEXING_GRID_LABELS.advRefNum}:</span>
                                                                <span className="doc-index-cust-value">{item.advRefNum}</span>
                                                            </div>
                                                        )}
                                                        <div className="doc-index-cust-label-row">
                                                            <span className="doc-index-cust-label">{documateLabel.INDEXING_GRID_LABELS.status}:</span>
                                                            <span className="doc-index-cust-value">
                                                                <span className={item.status === documateLabel.CUSTOMER_STATUS.active ? 'doc-index-cust-active-status' : ''}>
                                                                    {item.status}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="doc-index-cust-label-row">
                                                            <span className="doc-index-cust-label">{documateLabel.INDEXING_GRID_LABELS.fullName}:</span>
                                                            <span className="doc-index-cust-value">{item.fullName}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            showCustomerGrid && <div className="doc-index-cust-no-record">No record found.</div>
                                        )}

                                    </Column>
                                </Column>
                            </Row>
                            <Row className='rowmargin'>
                                <Column lg={12} md={12}>
                                    <Select
                                        id="ddlDocumentType"
                                        controlId="ddlDocumentType"
                                        className={`mb-3`}
                                        label={documateLabel.INDEXING_PROCESSING_LABELS.documentType}
                                        options={sampleDocumentType}
                                        onChange={(value) => {
                                            handleDocumentTypeChange(value);
                                        }}

                                        defaultSelected={
                                            sampleDocumentType?.filter(({ value }) => value === documentTypeOption)
                                        }
                                        placeholder="Choose Type..."
                                        tabIndex={6}
                                        isRequired={true}
                                        isInvalid={formValidation.documentType?.isValid === false}
                                        invalidWarning={formValidation.documentType?.warningText}
                                    />
                                </Column>
                            </Row>

                            <Row className='indexbutton'>
                                <Column lg={12} md={12} className='d-flex justify-content-end flex-nowrap gap-2'>
                                    {queueDocs.length > 1 ? (
                                        <>
                                            <Button
                                                className='btn btn-primary bt-main-action'
                                                size='small'
                                                onClick={handleSkipButtonclick}
                                                tabIndex={7}
                                                id='Skip'
                                                disabled={isDisabled}
                                            >
                                                {documateLabel.DOCUMATE_INDEXING_BUTTONS.skip}
                                            </Button>
                                            <Button
                                                className='btn btn-primary bt-main-action'
                                                size='small'
                                                onClick={() => handleIndexButtonclick(false)}
                                                tabIndex={7}
                                                id='IndexAndNext'
                                                disabled={isDisabled}
                                            >
                                                {documateLabel.DOCUMATE_INDEXING_BUTTONS.indexAndNext}
                                            </Button>
                                            <Button
                                                className='btn btn-primary bt-main-action'
                                                size='small'
                                                onClick={() => handleIndexButtonclick(true)}
                                                tabIndex={7}
                                                id='IndexAndEnd'
                                                disabled={isDisabled}
                                            >
                                                {documateLabel.DOCUMATE_INDEXING_BUTTONS.indexAndEndAutoprocessing}
                                            </Button>
                                        </>
                                    ) : (
                                        <Button
                                            className='btn btn-primary bt-main-action'
                                            size='small'
                                            onClick={() => handleIndexButtonclick(false)}
                                            tabIndex={7}
                                            id='Index'
                                            disabled={isDisabled}
                                        >
                                            {documateLabel.DOCUMATE_INDEXING_BUTTONS.index}
                                        </Button>
                                    )}
                                </Column>
                            </Row>
                        </Panel>
                    </Column>
                    <Column lg={6} md={6}>
                        {showPolicyDetails &&
                            <Panel title={documateLabel.INDEXING_IMAGING_TASK_LABELS.policy_term}>
                                <Row>{policiesPanel}</Row>
                            </Panel>}
                             {showOneStepPanel &&
                            <Panel title={documateLabel.INDEXING_IMAGING_TASK_LABELS.One_Step}>
                            <Row>                               
                              <div className="oneStepPanel">
                                <span
                                    tabIndex={0}
                                    role="button"
                                    onClick={() => setIsOneStepSelected(!isOneStepSelected)}                                   
                                    className={isOneStepSelected ? 'selected-folder-name' : ''}                                   
                                >
                                    {docuMateConstant.NoPolicyFolderName}
                                </span>
                             </div>    
                            </Row>
                            </Panel>}
                    </Column>
                </Row>

                <Row>
                    <Column lg={6} md={6}>
                        <Panel title={scanId} panelHeaderItems={getStatusIcon} className='thirdPanelClass'>
                            <Row>
                                <Column lg={12} md={12}>
                                    <Select
                                        id="ddlGroup"
                                        controlId="ddlGroup"
                                        className={`mb-2`}
                                        label={documateLabel.INDEXING_IMAGING_TASK_LABELS.redirect_to_group}
                                        options={sampleGroup}
                                        defaultSelected={sampleGroup?.filter(({ value }) => value === selectedGroupOption)}
                                        onChange={
                                            (value) => onGroupSelectChange(value)

                                        }
                                        placeholder={'Choose Group...'}
                                        tabIndex={8}
                                        isRequired={true}
                                        isInvalid={formValidation.group?.isValid === false}
                                        invalidWarning={formValidation.group?.warningText}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12}>
                                    <Select
                                        id="ddlFolder"
                                        controlId="ddlFolder"
                                        className={`mb-2`}
                                        label={documateLabel.INDEXING_IMAGING_TASK_LABELS.folder}
                                        options={sampleFolder}
                                        defaultSelected={sampleFolder?.filter(({ value }) => value === selectedFolderOption)}
                                        onChange={
                                            (value) => handleFolderChange(value)
                                        }
                                        placeholder={'Choose Folder...'}
                                        tabIndex={9}
                                        isRequired={true}
                                        isInvalid={formValidation.folder?.isValid === false}
                                        invalidWarning={formValidation.folder?.warningText}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12}>
                                    <Select
                                        id="ddlPerson"
                                        controlId="ddlPerson"
                                        className="mb-2"
                                        label={documateLabel.INDEXING_IMAGING_TASK_LABELS.person}
                                        options={userList}
                                        defaultSelected={userList?.filter(({ value }) => value === userOption)}
                                        onChange={
                                            (value) => handleUserChange(value)
                                        }
                                        placeholder={'Choose Person...'}
                                        tabIndex={10}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12}>
                                    <Select
                                        id="ddlRedirectReason"
                                        controlId="ddlRedirectReason"
                                        className="mb-2"
                                        label={documateLabel.INDEXING_IMAGING_TASK_LABELS.redirect_reason}
                                        options={sampleRedirectReason}
                                        onChange={
                                            (value) => handleRedirectReasonChange(value)
                                        }
                                        defaultSelected={sampleRedirectReason?.filter(({ value }) => value === redirectReasonOption)}
                                        placeholder={'Choose Reason...'}
                                        tabIndex={11}
                                        isRequired={true}
                                        isInvalid={formValidation.redirectReason?.isValid === false}
                                        invalidWarning={formValidation.redirectReason?.warningText}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column lg={12} md={12}>
                                    <FloatingLabel
                                        controlId="redirectnote"
                                        label={
                                            <>
                                                {"Redirect Note"}
                                                {isRedirectNoteRequired && <span className="text-danger ms-1">*</span>}
                                            </>
                                        }
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            placeholder={"Redirect Note"}
                                            name="redirectnote"
                                            value={newRedirectNote}
                                            onChange={(e) => {
                                                setNewRedirectNote(e.target.value);
                                            }}


                                            tabIndex={12}
                                            maxLength={250}
                                            isInvalid={isRedirectNoteRequired && formValidation.redirectNote?.isValid === false}
                                            required={isRedirectNoteRequired}
                                        />
                                        {formValidation.redirectNote?.isValid == false && (
                                            <Form.Control.Feedback type="invalid">
                                                {formValidation.redirectNote?.warningText}
                                            </Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>

                                </Column>
                            </Row>
                            <Row style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
                                {haveDelCloseAccess && (<Column sm={2} md={2} lg={2}>
                                    <Button
                                        outlined
                                        className="ms-auto me-2"
                                        color="info"
                                        size="small"
                                        onClick={handleClose}
                                        tabIndex={13}
                                    >
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.close}
                                    </Button>
                                </Column>)}

                                <Column sm={5} md={5} lg={5} className='placeOnHoldColumnClass'>
                                    <Button

                                        outlined={true}
                                        className="ms-auto me-8"
                                        color="info"
                                        size="small"
                                        onClick={handlePlaceOnHold}
                                        tabIndex={14}
                                        disabled={isDisabled}
                                    >
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.placeOnHold}
                                    </Button>
                                </Column>
                                <Column sm={2} md={2} lg={2} className='ResetBtnColumnClass'>
                                    <Button
                                        outlined={true}
                                        className="ms-auto me-2"
                                        color="info"
                                        size="small"
                                        onClick={handleReset}
                                        tabIndex={15}
                                        disabled={isDisabled}>
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.reset}
                                    </Button>
                                </Column>
                                <Column sm={2} md={2} lg={2} className='updateBtnColumnClass'>
                                    <Button
                                        outlined={true}
                                        className="ms-auto me-2"
                                        color="info"
                                        size="small"
                                        onClick={handleUpdate}
                                        tabIndex={16}
                                        disabled={isDisabled}>
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.update}
                                    </Button>
                                </Column>

                                {haveDelCloseAccess && (<Column sm={2} md={2} lg={2} className='DeleteBtnColumnClass'>
                                    <Button
                                        outlined={true}
                                        className="ms-auto me-2"
                                        color="info"
                                        size="small"
                                        onClick={handleDelete}
                                        tabIndex={17}
                                        disabled={isDisabled}
                                    >
                                        {documateLabel.DOCUMATE_INDEXING_BUTTONS.delete}
                                    </Button>
                                </Column>)}
                            </Row>
                        </Panel>
                    </Column>
                    <Column lg={6} md={6}>
                        <Panel>
                            <Row>
                                {renderNotes(docHistory)}
                            </Row>
                            <div className="notes-footer">
                                <Row>
                                    <Column lg={9} md={9} sm={9}>
                                        <TextInput
                                            id="txtAddNote"
                                            type="text"
                                            size="sm"
                                            maxLength={250}
                                            value={newNote}
                                            onChange={(e) => {
                                                setNewNote(e.target.value);
                                                setNoteError(false); // Reset error on change
                                            }}
                                            placeholder="Add a note..."
                                            isInvalid={noteError}
                                            tabIndex={lastTabIndex + 1}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleAddNote();
                                                }
                                            }}
                                        />
                                    </Column>
                                    <Column lg={3} md={3} sm={3}>
                                        <ReactButton
                                            className="btn btn-primary"
                                            size="small"
                                            onClick={handleAddNote}
                                            tabIndex={lastTabIndex + 2}
                                            ref={lastButtonRef}
                                            onKeyDown={(e) => {
                                                if (e.key == "Tab" && !e.shiftKey) {
                                                    firstControlRef.current.focus();
                                                    e.preventDefault();
                                                }
                                            }}
                                            disabled={isDisabled}
                                        >
                                            {documateLabel.DOCUMATE_INDEXING_BUTTONS.submit}
                                        </ReactButton>
                                    </Column>
                                </Row>
                            </div>
                        </Panel>
                    </Column>
                </Row>
            </div>

            <div className='doc-view-container-indexing'>
                {docPdf ? (
                    <DocViewer document={docPdf} scanId={docNameAPI} />
                ) : (
                    <div>Loading document...</div>
                )}
            </div>

            {/* Confirm Modal */}
            <ConfirmModal
                modaltitle="Confirmation"
                showConfirmation={showConfirmModal}
                setConfirmation={(isModalOpen) => setShowConfirmModal(isModalOpen)}
                body={modalBody}
                closeButtonClick={() => {
                    setShowConfirmModal(false)
                    setWhichBtnClickedForModal('')
                }} // Close the modal
                successButtonClick={() => modalSuccess(whichBtnClickedForModal)}
                closeButtonLabel="No"
                successButtonLabel="Yes"
            />
        </div>

    );

};


export default DocuMateIndexing;

